<template>
    <async-btn
            :task="task"
            color="primary"
            label="Move to Timeline"
            v-bind="$attrs"
            @click="save"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import notify from '@/components/notify';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { save } from '../post';

interface Data {
  task: Promise<Post>|null,
}

export default defineComponent({
  emits: ['saved'],
  components: { AsyncBtn },
  props: {
    postId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    save() {
      this.task = save(this.postId);
      this.task.then((post: Post) => {
        this.$emit('saved', post);
        notify('Post moved to timeline');
      });
    },
  },
});
</script>
